import { Box, Button, Modal } from '@stitch-fix/mode-react';
import { JsonRteRenderer } from '../JsonRteRenderer';
import { CloudinaryPicture } from '../CSCloudinaryAsset/Picture';
import styles from './style.module.scss';
import type { CloudinaryImageFields } from '../CloudinaryImageWrapper';
import type { ContentStackJSONRichText } from '../../../scripts/schemaGenerator/fields/rte';
import { isNonEmptyString } from '../../utils/helpers';

export type SlimBannerModalProps = {
  isOpen: boolean;
  close: () => void;
  heading: ContentStackJSONRichText;
  body: ContentStackJSONRichText;
  image: CloudinaryImageFields;
  cta: {
    text: string;
    href: string;
  };
};

export const SlimBannerModal = ({
  isOpen,
  close,
  heading,
  body,
  image,
  cta,
}: SlimBannerModalProps) => {
  const isCtaDataValid =
    isNonEmptyString(cta.href) && isNonEmptyString(cta.text);

  return (
    <Modal
      isOpen={isOpen}
      onClose={close}
      heading={
        <div style={{ textWrap: 'balance' }}>
          <JsonRteRenderer
            data={heading}
            options={{ textProps: { h1: { setting: 'title-small' } } }}
          />
        </div>
      }
      hero={
        <div className={styles.image}>
          <CloudinaryPicture
            alt={image.alt}
            sources={[
              {
                minWidth: 0,
                cloudinaryAsset: image.cloudinaryAsset,
              },
              {
                minWidth: 560,
                cloudinaryAsset: image.cloudinaryAsset,
              },
            ]}
          />
        </div>
      }
      variant="inset-small"
      hAlign="center"
      bodyLock="never"
    >
      <JsonRteRenderer data={body} />
      <Box maxWidth={18} mx="auto" mt={1}>
        <Button
          as="a"
          href={isCtaDataValid ? cta.href : '/signup'}
          variant="filled-staple"
          data-testid="modal-cta"
          onClick={close}
        >
          {isCtaDataValid ? cta.text : 'Sign up'}
        </Button>
      </Box>
    </Modal>
  );
};
